import { render } from "./BedOccupancyRateChart.vue?vue&type=template&id=1d072eca&ts=true"
import script from "./BedOccupancyRateChart.vue?vue&type=script&lang=ts"
export * from "./BedOccupancyRateChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__